import React, { FunctionComponent, useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import { useReviewPaymentGtm } from '../../hooks/gtm/reviewPayment/useReviewPaymentGtm';
import { useOrder } from '../../hooks/order/useOrder';
import CardBox from '../../components/CardBox';
import StepItem from '../../components/StepItem';
import Layout from '../../containers/Layout';
import { listItems } from './Helpers/list-items';
import {
  Container,
  SubTitle,
  Title,
  Text,
  SplitMessage,
  ImageTitle,
  Icon,
} from './styles';
import LgpdCard from '../../components/LgpdCard';
import { Order } from '../../requests/caipirinha-api/interfaces/order.interface';
import IcPix from '../../assets/icons/ic_pix.svg';

const Pix: FunctionComponent = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [orderPayment, setOrderPayment] = useState<Order>();
  const { id, document } = useParams<{ id: string; document: string }>();
  const { order, lgpd, getOrderByIdAndDocument, confirmLoading } = useOrder();
  const { sendDataToGtm: sendReviewPaymentDataToGtm } = useReviewPaymentGtm();

  const { location } = useHistory();
  const locationState: any = location.state;

  useEffect(() => {
    if (locationState?.resultPayment) {
      setOrderPayment(locationState.resultPayment);
      sendReviewPaymentDataToGtm(locationState.resultPayment);
      setLoading(false);
    } else {
      getOrderByIdAndDocument(id, document);
    }
  }, [id, document]);

  useEffect(() => {
    if (!confirmLoading) setLoading(confirmLoading);
  }, [confirmLoading]);

  useEffect(() => {
    if (order) {
      setOrderPayment(order);
      sendReviewPaymentDataToGtm(order);
      setLoading(false);
    }
  }, [order]);

  return (
    <Layout dark loading={loading}>
      <Container>
        <CardBox>
          <Title data-cy='pix-code'>Código Pix</Title>

          <SubTitle data-cy="send-pix-code-text">
            Pedido recebido. Para finalizar, basta enviar o código Pix ao
            cliente.
          </SubTitle>

          <Text data-cy='order-number-text' variant="medium">Número do pedido:</Text>

          <Text data-cy='order-number' variant="largerBold" vMargin="20">
            {orderPayment?.referenceNumber}
          </Text>

          <Text data-cy='whatsapp-confirm-order-text' variant="medium">
            A confirmação do pedido foi enviada pelo Whatsapp da Lu!
          </Text>

          <SplitMessage />

          <ImageTitle>
            <Icon data-cy='payment-icon' src={IcPix} />
            <SubTitle data-cy='payment-text' vMargin="5">Pagamento via Pix</SubTitle>
          </ImageTitle>

          <Text data-cy='pix-info' variant="small" vMargin="20">
            Pagar com o Pix é super fácil! Além de ser instantâneo, é confirmado
            em poucos segundos.
          </Text>

          {listItems(orderPayment).map((item, index) => (
            <StepItem
              data-cy={`step-${index}`}
              key={item.step}
              step={item.step}
              description={item.description}
            >
              {item.children}
            </StepItem>
          ))}

          <Text data-cy='payment-cancel-info' variant='smallBold' vMargin="32">
            Se o pagamento não for confirmado, não se preocupe. O pedido será
            cancelado automaticamente.
          </Text>
        </CardBox>
      </Container>
      {lgpd?.self && <LgpdCard url={lgpd.self.offerPolicy} />}
    </Layout>
  );
};

export default Pix;
